$(() => {
  $("body").on("click", ".featured-on a", function trackFeatured() {
    const url = $(this).attr("href")
    Activity.track("link", "click", url)
  })

  $("body").on("click", ".travel-ideas a", function trackTravelIdeas() {
    const name = $(this).find(".js-travel-ideas--header").text()
    const category =
      $(this).closest(".travel-ideas").data("activity-category") ||
      "travel-ideas"
    Activity.track(category, "click", name)
  })

  $("body").on(
    "click",
    ".js-track-activity, .top-locations--i, .offers_top-picks .card, .offers_special-deals .card",
    function trackActivity() {
      Activity.track(
        $(this).data("activity-category"),
        "click",
        $(this).data("activity-label"),
      )
    },
  )
})
